import React, { useEffect } from "react";

/** Wraps TV routes (hard refresh lives on /tv home only — see TvRefreshButton). */
export default function TvShell({ children }) {
  useEffect(() => {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("_refresh")) return;
    url.searchParams.delete("_refresh");
    const next = url.pathname + url.search + url.hash;
    window.history.replaceState({}, "", next);
  }, []);

  return children;
}
